<template>
  <v-layout
    row
    mb-4
    :align-start="customerTrackingLog.body.includes('<br>')"
    :align-center="!customerTrackingLog.body.includes('<br>')"
  >
    <v-flex class="xs8-5">
      <div class="customer-tracking-log-item__avatar">
        <v-icon color="black">{{ logIcons[logType] }}</v-icon>
      </div>
    </v-flex>
    <v-flex class="xs11-15">
      <span v-html="customerTrackingLog.body" />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    customerTrackingLog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logIcons: {
        'SEGUIMIENTO CREADO': 'call',
        'SEGUIMIENTO AGENDANDO': 'calendar_today',
        'SEGUIMIENTO GESTIONANDOSE': 'schedule',
        'SEGUIMIENTO RETRASADO': 'error',
        'SEGUIMIENTO CERRADO': 'check_circle',
      },
    };
  },
  computed: {
    logType() {
      return this.customerTrackingLog
        .body
        .replaceAll('<strong>', '')
        .trim()
        .split('</strong>')
        .shift()
        .toUpperCase();
    },
  },
};
</script>

<style scoped>
.customer-tracking-log-item__avatar {
  background-color: #FFFFFF;
  border: 1px solid #707070;
  width: 33px;
  height: 33px;
  margin-right: 15px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.xs8-5 {
  flex-basis: 7% !important;
  max-width: 7% !important;
  -ms-flex-preferred-size: 7% !important;
  -webkit-box-flex: 0 !important;
  -ms-flex-positive: 0 !important;
}

.xs11-15 {
  flex-basis: 92% !important;
  max-width: 92% !important;
  -ms-flex-preferred-size: 92% !important;
  -webkit-box-flex: 0 !important;
  -ms-flex-positive: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerTrackingLogItem.vue